import { render, staticRenderFns } from "./PixInstallmentPlanCard.vue?vue&type=template&id=08523353&scoped=true"
import script from "./PixInstallmentPlanCard.vue?vue&type=script&lang=js"
export * from "./PixInstallmentPlanCard.vue?vue&type=script&lang=js"
import style0 from "./PixInstallmentPlanCard.vue?vue&type=style&index=0&id=08523353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08523353",
  null
  
)

export default component.exports